import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import * as styles from './CookieBanner.module.scss';

const STORAGE_KEY = 'cookie_consent';

function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.banner}>
      <span className={styles.text}>This site uses cookies.</span>
      <Link to="/privacy-policy" className={styles.link}>Privacy Policy</Link>
      <button type="button" className={styles.accept} onClick={accept}>Accept</button>
    </div>
  );
}

export default CookieBanner;
